import type { NUserPreview } from '@pages/Users/UserPreview/UserPreview.types';

export const BranchesInfo: NUserPreview.BranchesInfo = ({ user, chains }) => {
  return (
    <div className="branches-info-container">
      <ul style={{ margin: '0' }}>
        {user?.UserBranches.map((branch) => {
          return (
            <li key={branch.BranchId} data-testid="branch-item">
              {branch.Name}{' '}
              {branch.ChainId
                ? `(сеть: ${
                    (chains || []).find(({ Id }) => Id === branch.ChainId)
                      ?.Name || 'не определена'
                  })`
                : ''}
            </li>
          );
        })}
      </ul>
    </div>
  );
};
